import React, { useEffect, useRef } from "react";
import "./MessagePopup.css";
import { Message } from "../../../core/types/Message.model";
import { Popup } from "../Popup.tsx/Popup";



interface MessagePopupProps {
  message: Message;
}

export const MessagePopup: React.FC<MessagePopupProps> = ({ message }) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (dialogRef.current && !dialogRef.current.open) {
      dialogRef.current.showModal();
    }
  }, [message]);

  return (
    <Popup
      additionalClass={message.type}
      closeAction={message.closeAction}
      actions={message.actions}>

      {/* Header */}

      <div className="message-popup-header">
        <h1>{message.header}</h1>
      </div>


      {/* Body */}
      <div className="message-popup-body">
        <p>{message.text}</p>

      </div>


    </Popup>
  );
};
